import { DAYS } from '~src/constants';

// Availability is stored as a flat list of weekday strings, but some older
// edit paths can carry a nested array. Flatten one level and keep only the
// canonical weekday names the backend expects.
const flattenDays = (timeframes) => (timeframes || []).flat().filter((day) => DAYS.includes(day));

// Builds the request body for the suggest-note endpoint from whatever the
// current form holds. Returns null when the essentials are missing so the
// caller can keep the suggest action disabled instead of sending a useless
// request.
export const buildSuggestNotePayload = ({ userRole, address, rateInCents, timeframes, languages }) => {
  if (!address?.city || !address?.country || !Number.isFinite(rateInCents)) {
    return null;
  }

  return {
    user_role: userRole,
    location: {
      city: address.city,
      country: address.country,
      address: address.address,
    },
    hourly_rate: Math.round(rateInCents / 100),
    available_days: flattenDays(timeframes),
    speaking_language: languages || [],
  };
};
